// Languages
export const LANGUAGE_MAP = {
  1: 'English',
  2: 'Spanish',
  3: 'Portuguese',
  4: 'Japanese',
  5: 'Chinese',
  6: 'Russian',
  7: 'French',
  8: 'German',
};

// Regions
export const REGION_TZ_MAP = {
  1: 'North America / Pacific Standard',
  2: 'North America / Mountain Standard',
  3: 'North America / Central Standard',
  4: 'North America / Eastern Standard',
};
export const REGION_MAP = {
  1: 'North America',
  2: 'North America',
  3: 'North America',
  4: 'North America',
};

// Weekday labels used on availability selection
export const WEEK_DAYS = {
  '0': 'Sun',
  '1': 'Mon',
  '2': 'Tues',
  '3': 'Wed',
  '4': 'Thurs',
  '5': 'Fri',
  '6': 'Sat',
};

export const minServicePricePerHour = 0;
export const maxServicePricePerHour = 100;

/*
 * Hours throughout the day
 *
 * {
 *   0: "12am",
 *   60: "1am",
 *   ...
 *   720: "12pm",
 *   ...
 *   1380: "11pm"
 * }
 */
export const HOUR_BY_MINUTE_MAP = Array.from(new Array(25))
  .reduce(
    (accumulator, _, hourIndex) => {
      const hour = hourIndex > 12 ? hourIndex - 12 : hourIndex;
      const amPm = (hourIndex >= 12 && hourIndex < 24) ? 'pm' : 'am';
      accumulator[hourIndex * 60] = `${hour === 0 ? 12 : hour}${amPm}`;
      return accumulator;
    },
    {});

export const HOUR_BY_MINUTE_MAP_FULL = Array.from(new Array(25))
  .reduce(
    (accumulator, _, hourIndex) => {
      const hour = hourIndex > 12 ? hourIndex - 12 : hourIndex;
      const amPm = (hourIndex >= 12 && hourIndex < 24) ? 'pm' : 'am';
      accumulator[hourIndex * 60] = `${hour === 0 ? 12 : hour}:00${amPm}`;
      return accumulator;
    },
    {});

// Services offered
export const SERVICES = {
  'queue-buddy': 'Queue Buddy',
  'vod-review': 'VOD Review',
  // 'video-course': 'Access to video course',
  'gameplay-review': 'Live Gameplay Review',
  'voice-coach': 'Voice Comms coach',
  'teammate-coach': 'Teammate coach',
  'lobby-session': 'Streamer Showdown',
};

export const LOBBY_SESSION_SERVICE = 'lobby-session';

// Service charge types
export const SERVICE_CHARGE_TYPES = {
  'hour': 'Hourly payments',
};

// Games offered
export const GameAssetsPrefix = '/assets/queueup/game-assets/';
export const GameCardVariant = {
  'Square': 'square',
  'SquareBig': 'square-big',
  'Wide': 'wide',
  'WideBig': 'wide-big',
};
export const GAMES = {
  'apex-legends': {
    'slug': 'apex-legends',
    'title': 'Apex Legends',
    'logoSquare': GameAssetsPrefix + 'apex-legends-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'apex-legends-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'apex-legends-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'apex-legends-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'apex-legends-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'apex-legends-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'apex-legends-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'apex-legends-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'apex-legends-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'apex-legends-favicon-orange.png',
  },
  'call-of-duty-cold-war': {
    'slug': 'call-of-duty-cold-war',
    'title': 'Call of Duty: Cold War',
    'logoSquare': GameAssetsPrefix + 'call-of-duty-cold-war-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'call-of-duty-cold-war-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'call-of-duty-cold-war-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'call-of-duty-cold-war-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'call-of-duty-cold-war-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'call-of-duty-cold-war-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'call-of-duty-cold-war-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'call-of-duty-cold-war-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'call-of-duty-cold-war-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'call-of-duty-cold-war-favicon-orange.png',
  },
  'cs-go': {
    'slug': 'cs-go',
    'title': 'CS:GO',
    'logoSquare': GameAssetsPrefix + 'cs-go-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'cs-go-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'cs-go-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'cs-go-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'cs-go-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'cs-go-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'cs-go-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'cs-go-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'cs-go-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'cs-go-favicon-orange.png',
  },
  'fortnite': {
    'slug': 'fortnite',
    'title': 'Fortnite',
    'logoSquare': GameAssetsPrefix + 'fortnite-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'fortnite-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'fortnite-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'fortnite-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'fortnite-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'fortnite-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'fortnite-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'fortnite-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'fortnite-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'fortnite-favicon-orange.png',
  },
  'league-of-legends': {
    'slug': 'league-of-legends',
    'title': 'League of Legends',
    'logoSquare': GameAssetsPrefix + 'league-of-legends-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'league-of-legends-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'league-of-legends-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'league-of-legends-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'league-of-legends-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'league-of-legends-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'league-of-legends-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'league-of-legends-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'league-of-legends-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'league-of-legends-favicon-orange.png',
  },
  'rocket-league': {
    'slug': 'rocket-league',
    'title': 'Rocket League',
    'logoSquare': GameAssetsPrefix + 'rocket-league-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'rocket-league-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'rocket-league-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'rocket-league-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'rocket-league-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'rocket-league-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'rocket-league-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'rocket-league-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'rocket-league-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'rocket-league-favicon-orange.png',
  },
  'teamfight-tactics': {
    'slug': 'teamfight-tactics',
    'title': 'Teamfight Tactics',
    'logoSquare': GameAssetsPrefix + 'teamfight-tactics-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'teamfight-tactics-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'teamfight-tactics-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'teamfight-tactics-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'teamfight-tactics-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'teamfight-tactics-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'teamfight-tactics-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'teamfight-tactics-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'teamfight-tactics-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'teamfight-tactics-favicon-orange.png',
  },
  'valorant': {
    'slug': 'valorant',
    'title': 'Valorant',
    'logoSquare': GameAssetsPrefix + 'valorant-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'valorant-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'valorant-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'valorant-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'valorant-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'valorant-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'valorant-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'valorant-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'valorant-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'valorant-favicon-orange.png',
  },
  'warzone': {
    'slug': 'warzone',
    'title': 'Warzone',
    'logoSquare': GameAssetsPrefix + 'warzone-logo-75x75.png',
    'logoSquareBig': GameAssetsPrefix + 'warzone-logo-160x160.png',
    'logoWide': GameAssetsPrefix + 'warzone-logo-325x50.png',
    'logoWideBig': GameAssetsPrefix + 'warzone-logo-800x75.png',
    'coverSquare': GameAssetsPrefix + 'warzone-cover-75x75.jpg',
    'coverSquareBig': GameAssetsPrefix + 'warzone-cover-160x160.jpg',
    'coverWide': GameAssetsPrefix + 'warzone-cover-325x50.jpg',
    'coverWideBig': GameAssetsPrefix + 'warzone-cover-800x75.jpg',
    'faviconFullColor': GameAssetsPrefix + 'warzone-favicon-full-color.png',
    'faviconOrange': GameAssetsPrefix + 'warzone-favicon-orange.png',
  },
};

export const GAME_LIST = Object.values(GAMES);

export const GAME_FILTER_DEFAULT = ['league-of-legends', 'fortnite', 'warzone', 'call-of-duty-cold-war'];

export const CoachesPerGame = {
  'apex-legends': 0,
  'call-of-duty-cold-war': 17,
  'cs-go': 321,
  'fortnite': 208,
  'league-of-legends': 319,
  'rocket-league': 175,
  'valorant': 0,
  'warzone': 85,
};

export const TRAIT_MAP = {
  'friendly': 'Friendly',
  'professional': 'Professional',
  'motivating': 'Motivating',
  'good-goal-setting': 'Good Goal Setting',
  // 'good-with-kids': 'Good With Kids',
  'fun-sessions': 'Fun Sessions',
  'professional-experience': 'Professional Experience',
  'strict': 'Strict',
  'relaxed': 'Relaxed',
  'proven-results-with-students': 'Proven Results With Students',
  'highly-rated': 'Highly Rated',

  // @TODO: need icons defined for the following traits
  // 'skilled-player': 'Skilled Player',
  // 'streamer-friendly': 'Streamer Friendly',
  // 'streamer': 'Streamer',
  // 'good-listener': 'Good Listener',
  // 'in-game-carry': 'In-Game Carry',
  // 'fast-responses': 'Fast Responses',
  // 'funny': 'Funny',
};

export const TRAIT_LIST = Object.keys(TRAIT_MAP).map(e => ({
  slug: e,
  displayName: TRAIT_MAP[e],
}));

// Actions required when there are conflicting orders
export const CONFLICTING_ORDERS_ACTION = {
  KEEP: 'keep',
  CANCEL: 'cancel',
  ERROR: 'error',
};

export const Q_SURVEY_TARGET = {
  1: 'A coach that will help me improve',
  2: 'A partner to play with',
  3: 'A skilled Player that will help me rank up',
  4: 'Just browsing',
};

export const Q_SURVEY_EXPERIENCE = {
  1: "It's been great!",
  2: "It's been good!",
  3: "It's been ok!",
  4: "It's been frustrating!",
};
